(function (g) {
/**
 * MILO catalog fuzzy search — Fuse.js + category anchors + confidence rules.
 * Used by automated QA (Node) and theme browser bundle.
 */
  const Fuse = g.Fuse || (typeof require === "function" ? require("fuse.js") : null);
  if (!Fuse) throw new Error("Fuse.js required");

const NO_MATCH =
  "Ik vind hiervoor nog geen betrouwbare productmatch in de voorbereide MUSKLE data. Probeer bijvoorbeeld: creatine, whey, magnesium, omega 3, pre-workout of aminozuren.";
const AMBIGUOUS =
  "Ik twijfel wat je precies zoekt. Bedoel je bijvoorbeeld creatine, whey, magnesium, omega 3 of aminozuren?";
const SUCCESS =
  "Dit zijn producten uit de voorbereide MUSKLE data die bij je vraag kunnen passen:";

const THRESHOLDS = {
  STRONG: 0.38,
  MEDIUM: 0.52,
  ANCHOR_STRONG: 0.42,
  ANCHOR_MEDIUM: 0.55,
};

const FUSE_OPTIONS = {
  keys: [
    { name: "search_type", weight: 0.35 },
    { name: "search_tags", weight: 0.35 },
    { name: "search_title", weight: 0.22 },
    { name: "search_summary", weight: 0.06 },
    { name: "search_vendor", weight: 0.02 },
  ],
  threshold: 0.45,
  ignoreLocation: true,
  includeScore: true,
  minMatchCharLength: 2,
  shouldSort: true,
};

const CATEGORY_ANCHORS = [
  {
    id: "creatine",
    terms: ["creatine", "creatin", "kreatine", "creatine monohydrate", "creatine monohydraat"],
    matchProduct: /creatine|creatin|kreatine|creatine-monohydraat/i,
    conflict: /pre-workout|preworkout|amino-acid|aminozuren|bcaa|\beaa\b|liver|lever/i,
  },
  {
    id: "whey",
    terms: ["whey", "whay", "protein", "protien", "proteine", "eiwit", "whey protein", "whey isolate", "clear whey"],
    matchProduct: /whey|eiwit|protein|proteine|isolaat|isolate|clear whey/i,
    conflict: /creatine|magnesium|omega|pre-workout|collagen|collageen|zink|zinc|multivitamin|ashwagandha/i,
  },
  {
    id: "amino",
    terms: ["amino", "amino acid", "amino acids", "aminozuren", "aminozuur", "bcaa", "eaa", "aminoazid", "amonoazid"],
    matchProduct: /amino|bcaa|\beaa\b|aminozuren|amino-acid/i,
    conflict: /creatine|whey|omega|magnesium|collagen|collageen|zink|zinc|liver|lever/i,
  },
  {
    id: "preworkout",
    terms: ["pre workout", "pre-workout", "preworkout", "pump"],
    matchProduct: /pre-workout|preworkout|pump/i,
    conflict: /creatine-monohydraat|magnesium|omega|collagen|collageen|whey/i,
  },
  {
    id: "magnesium",
    terms: ["magnesium", "magnisium"],
    matchProduct: /magnesium/i,
    conflict: /creatine|whey|omega|pre-workout|amino|bcaa|collagen|collageen/i,
  },
  {
    id: "omega",
    terms: ["omega 3", "omega3", "omega-3", "omga 3", "fish oil", "visolie", "vis olie"],
    matchProduct: /omega|visolie|fish oil|vis-olie/i,
    conflict: /creatine|whey|magnesium|pre-workout|amino|bcaa|collagen|collageen/i,
  },
  {
    id: "collagen",
    terms: ["collagen", "collageen"],
    matchProduct: /collagen|collageen/i,
    conflict: /creatine|whey|omega|magnesium|pre-workout|amino|bcaa/i,
  },
  {
    id: "zinc",
    terms: ["zinc", "zink"],
    matchProduct: /zinc|zink/i,
    conflict: /creatine|whey|omega|magnesium|pre-workout|amino|bcaa|collagen/i,
  },
  {
    id: "multivitamin",
    terms: ["multivitamin", "multivitamine", "vitamine"],
    matchProduct: /multivitamin|multivitamine|vitamin/i,
    conflict: /creatine|whey|omega|pre-workout|amino|bcaa/i,
  },
  {
    id: "ashwagandha",
    terms: ["ashwagandha"],
    matchProduct: /ashwagandha/i,
    conflict: /creatine|whey|omega|pre-workout|amino|bcaa/i,
  },
  {
    id: "electrolytes",
    terms: ["electrolyte", "electrolytes", "elektrolyten", "hydration", "hydratatie"],
    matchProduct: /electrolyte|elektrolyt|hydratatie|hydration/i,
    conflict: /creatine-monohydraat|whey|omega|collagen/i,
  },
  {
    id: "massgainer",
    terms: ["mass gainer", "mass-gainer", "weight gainer"],
    matchProduct: /mass gainer|weight gainer|mass-gainer/i,
    conflict: /creatine-monohydraat|omega|pre-workout|amino/i,
  },
  {
    id: "creamofrice",
    terms: ["cream of rice"],
    matchProduct: /cream of rice|rice/i,
    conflict: /creatine|whey|omega|pre-workout|amino/i,
  },
  {
    id: "proteinbar",
    terms: ["protein bar", "proteinbar", "eiwitreep"],
    matchProduct: /protein bar|proteinbar|eiwitreep|protein-reep/i,
    conflict: /creatine|omega|pre-workout|amino/i,
  },
  {
    id: "shaker",
    terms: ["shaker"],
    matchProduct: /shaker/i,
    conflict: null,
  },
  {
    id: "veganprotein",
    terms: ["vegan protein", "plant protein", "vegan eiwit"],
    matchProduct: /vegan|plant.*protein|plantaardig.*eiwit/i,
    conflict: /creatine|omega|pre-workout|amino/i,
  },
];

const SAFETY_QUERY =
  /medicatie|medicijn|medication|bloedverdunner|warfarine|zwanger|zwangerschap|pregnant|pregnancy|borstvoeding|breastfeeding|allergie|allergy|can i take|mag ik dit nemen|kan ik dit nemen|geneest|genezen|ziekte|bijwerking|veilig|safe to take/i;

const STOPWORDS =
  /\b(ik|zoek|welke|beste|past|bij|mij|aanrader|alternatief|raad|je|aan|recommend|which|looking|for|search|please|iets|goed|do|you|the|a|an|met|voor|een|van|in|dit|dat|kan|mag|nemen|take|with|how|hoe|what|where|is|are|my|me|need|want|find|help|something|herstel|slaap|recovery|sleep|tell|about|show|use|using|used|product|guide|guides|extract|much|hoeveel|gebruik|gebruiken|zit|er|ingredienten|tijdens|laat|zien|toon|tonen|open|productgids|gids)\b/gi;

function isSafetyQuery(question) {
  return SAFETY_QUERY.test(String(question || ""));
}

function normalizeSearchText(str) {
  return String(str || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/omega\s*[-/]?\s*3/g, "omega3")
    .replace(/pre\s*[-/]?\s*workout/g, "preworkout")
    .replace(/[\/.-]/g, " ")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function extractSearchQuery(question) {
  let q = normalizeSearchText(question);
  q = q.replace(STOPWORDS, " ").replace(/\s+/g, " ").trim();
  return q;
}

function buildSearchDoc(product) {
  return {
    handle: product.handle,
    product,
    search_title: normalizeSearchText(product.title),
    search_type: normalizeSearchText(product.product_type),
    search_tags: normalizeSearchText((product.category_tags || []).join(" ")),
    search_summary: normalizeSearchText(product.short_summary),
    search_vendor: normalizeSearchText(product.vendor),
    search_blob: normalizeSearchText(
      [product.title, product.product_type, (product.category_tags || []).join(" "), product.short_summary, product.vendor].join(" ")
    ),
  };
}

function getProductHaystack(product) {
  return normalizeSearchText(
    [product.title, product.product_type, (product.category_tags || []).join(" "), product.short_summary].join(" ")
  );
}

let anchorFuse = null;
function getAnchorFuse() {
  if (anchorFuse) return anchorFuse;
  const docs = [];
  CATEGORY_ANCHORS.forEach((anchor) => {
    anchor.terms.forEach((term, idx) => {
      docs.push({ id: anchor.id, term: normalizeSearchText(term), idx });
    });
  });
  anchorFuse = new Fuse(docs, {
    keys: [{ name: "term", weight: 1 }],
    threshold: 0.5,
    ignoreLocation: true,
    includeScore: true,
    minMatchCharLength: 2,
  });
  return anchorFuse;
}

function detectCategoryAnchor(question) {
  if (isSafetyQuery(question)) return { id: null, confidence: "none", score: 1 };

  const query = extractSearchQuery(question) || normalizeSearchText(question);
  if (!query || query.length < 3) return { id: null, confidence: "none", score: 1 };

  const fuse = getAnchorFuse();
  const candidates = [query].concat(query.split(" ").filter((t) => t.length >= 4));
  let best = null;

  candidates.forEach((part) => {
    const results = fuse.search(part, { limit: 1 });
    if (!results.length) return;
    const hit = results[0];
    if (!best || hit.score < best.score) {
      best = { id: hit.item.id, score: hit.score, part };
    }
  });

  if (!best) return { id: null, confidence: "none", score: 1 };

  if (best.score <= THRESHOLDS.ANCHOR_STRONG) {
    return { id: best.id, confidence: "strong", score: best.score };
  }
  if (best.score <= THRESHOLDS.ANCHOR_MEDIUM) {
    return { id: best.id, confidence: "medium", score: best.score };
  }
  return { id: null, confidence: "none", score: best.score };
}

function productMatchesAnchor(product, anchorId) {
  const anchor = CATEGORY_ANCHORS.find((a) => a.id === anchorId);
  if (!anchor) return true;
  return anchor.matchProduct.test(getProductHaystack(product));
}

function productViolatesAnchor(product, anchorId) {
  const anchor = CATEGORY_ANCHORS.find((a) => a.id === anchorId);
  if (!anchor || !anchor.conflict) return false;
  const hay = getProductHaystack(product);
  if (anchor.matchProduct.test(hay)) return false;
  return anchor.conflict.test(hay);
}

function isWeakGenericQuery(query) {
  const q = normalizeSearchText(query);
  if (!q) return true;
  if (/\basdfgh\b|\bqwerty\b|\bxxxxx\b/.test(q)) return true;
  if (/^(supplement|supplements|voedingssupplement|product|products|iets goed|something good|product help)$/.test(q)) {
    return true;
  }
  if (q.length < 3) return true;
  if (/^[a-z]{1,2}$/.test(q)) return true;
  return false;
}

function getAnchorFallbackProducts(products, anchor) {
  if (!anchor.id || anchor.confidence !== "strong") return [];
  return products
    .filter((p) => productMatchesAnchor(p, anchor.id) && !productViolatesAnchor(p, anchor.id))
    .sort((a, b) => Number(b.answer_ready) - Number(a.answer_ready))
    .slice(0, 3);
}

function distinctiveTokens(question) {
  const q = extractSearchQuery(question) || normalizeSearchText(question);
  return q.split(" ").filter((t) => t.length >= 3);
}

function productCoversTokens(product, tokens) {
  if (!tokens.length) return true;
  const hay =
    getProductHaystack(product) + " " + normalizeSearchText(String(product.handle || "").replace(/-/g, " "));
  return tokens.every((t) => hay.includes(t));
}

function findExactIdentityMatches(question, products) {
  const q = normalizeSearchText(question);
  if (!q || q.length < 3) return [];
  return products.filter((p) => {
    const title = normalizeSearchText(p.title);
    const vendorTitle = normalizeSearchText([p.vendor, p.title].join(" "));
    const handleWords = normalizeSearchText(String(p.handle || "").replace(/-/g, " "));
    return title === q || vendorTitle === q || handleWords === q;
  });
}

function searchCatalog(question, products) {
  if (isSafetyQuery(question)) {
    return { status: "none", products: [], message: NO_MATCH, anchor: null, bestScore: null };
  }

  const rawQuery = normalizeSearchText(question);
  const query = extractSearchQuery(question);

  if (isWeakGenericQuery(query) && isWeakGenericQuery(rawQuery)) {
    return { status: "none", products: [], message: NO_MATCH, anchor: null, bestScore: null };
  }

  const searchText = query.length >= 3 ? query : rawQuery;
  if (!searchText || searchText.length < 3) {
    return { status: "none", products: [], message: NO_MATCH, anchor: null, bestScore: null };
  }

  const exact = findExactIdentityMatches(question, products);
  if (exact.length === 1) {
    return { status: "ok", products: exact, message: SUCCESS, anchor: null, bestScore: 0 };
  }
  if (exact.length > 1) {
    return { status: "ok", products: exact.slice(0, 3), message: SUCCESS, anchor: null, bestScore: 0 };
  }

  const tokens = distinctiveTokens(question);
  const anchor = detectCategoryAnchor(question);
  const docs = products.map(buildSearchDoc);
  const fuse = new Fuse(docs, FUSE_OPTIONS);
  const results = fuse.search(searchText, { limit: 16 });

  let ranked = results
    .map((r) => ({
      product: r.item.product,
      score: r.score ?? 1,
      answerReady: !!r.item.product.answer_ready,
    }))
    .filter((r) => typeof r.score === "number");

  if (anchor.id && anchor.confidence === "strong") {
    const anchored = ranked.filter((r) => productMatchesAnchor(r.product, anchor.id));
    if (anchored.length) ranked = anchored;
  }

  ranked.sort((a, b) => {
    if (a.answerReady !== b.answerReady) return Number(b.answerReady) - Number(a.answerReady);
    return a.score - b.score;
  });

  if (tokens.length) {
    const fromRanked = ranked.filter((r) => productCoversTokens(r.product, tokens));
    const coveredAll = products.filter((p) => productCoversTokens(p, tokens));
    if (coveredAll.length === 1) {
      return { status: "ok", products: coveredAll, message: SUCCESS, anchor, bestScore: fromRanked[0]?.score ?? 0 };
    }
    if (coveredAll.length >= 2 && coveredAll.length <= 3) {
      return { status: "ok", products: coveredAll, message: SUCCESS, anchor, bestScore: fromRanked[0]?.score ?? 0 };
    }
    if (fromRanked.length) {
      ranked = fromRanked;
    } else if (!coveredAll.length) {
      return { status: "none", products: [], message: NO_MATCH, anchor, bestScore: ranked[0]?.score ?? null };
    }
  }

  if (!ranked.length || ranked[0].score > THRESHOLDS.MEDIUM) {
    const fallback = getAnchorFallbackProducts(products, anchor);
    if (fallback.length) {
      return {
        status: "ok",
        products: fallback,
        message: SUCCESS,
        anchor,
        bestScore: ranked[0]?.score ?? null,
      };
    }
    if (anchor.confidence === "medium") {
      return { status: "ambiguous", products: [], message: AMBIGUOUS, anchor, bestScore: ranked[0]?.score ?? null };
    }
    return { status: "none", products: [], message: NO_MATCH, anchor, bestScore: ranked[0]?.score ?? null };
  }

  if (ranked[0].score > THRESHOLDS.STRONG && anchor.confidence !== "strong") {
    if (anchor.confidence === "medium") {
      return { status: "ambiguous", products: [], message: AMBIGUOUS, anchor, bestScore: ranked[0].score };
    }
    return { status: "none", products: [], message: NO_MATCH, anchor, bestScore: ranked[0].score };
  }

  const cards = [];
  for (const row of ranked) {
    if (row.score > THRESHOLDS.MEDIUM) break;
    if (anchor.id && productViolatesAnchor(row.product, anchor.id)) continue;
    cards.push(row.product);
    if (cards.length >= 3) break;
  }

  if (!cards.length) {
    const fallback = getAnchorFallbackProducts(products, anchor);
    if (fallback.length) {
      return {
        status: "ok",
        products: fallback,
        message: SUCCESS,
        anchor,
        bestScore: ranked[0]?.score ?? null,
      };
    }
    if (anchor.confidence === "medium") {
      return { status: "ambiguous", products: [], message: AMBIGUOUS, anchor, bestScore: ranked[0]?.score ?? null };
    }
    return { status: "none", products: [], message: NO_MATCH, anchor, bestScore: ranked[0]?.score ?? null };
  }

  return {
    status: "ok",
    products: cards,
    message: SUCCESS,
    anchor,
    bestScore: ranked[0].score,
  };
}


  g.MiloSearchEngine = {
    NO_MATCH, AMBIGUOUS, SUCCESS, THRESHOLDS,
    normalizeSearchText, extractSearchQuery, detectCategoryAnchor,
    searchCatalog, productMatchesAnchor, productViolatesAnchor,
    buildSearchDoc, CATEGORY_ANCHORS,
  };
})(typeof globalThis !== 'undefined' ? globalThis : this);
